import PropTypes from 'prop-types'
import React from 'react'

import {Cancel, Continue, ControlButton} from '../../../../../shared_components/ButtonTypes'
import Modal from '../../../../../shared_components/Modal'
import modalWrapper from '../../../../../shared_components/ModalWrapper'
import ShadowHeader from '../ShadowHeader'
import StatusToggle from './StatusToggle'

import FirmActions from '../../../actions/FirmActions'

import './editFirmConfig.scss'

import ContactAccountManagerNote from './ContactAccountManagerNote'
import ShadowWrapper from '../ShadowWrapper'

const TEXTS = {
  disabled: 'Clients and firm users will not be required to set up two-factor authentication during signup.',
  enabled: 'Clients and firm users will be required to set up two-factor authentication during signup.'
}

const ORG_OVERRIDE_NOTE = 'This firm is a part of an organization that requires mandatory two-factor authentication.'
const ORG_CONFIG_UNKNOWN_NOTE = "We couldn't load organization-level mandatory two-factor authentication settings. Please refresh and try again."

export class EditMandatoryTfa extends React.Component {
  constructor(props) {
    super(props)

    this.state = {isEnabled: props.mandatoryTfaEnabled}

    this.resetMandatoryTfaState = this.resetMandatoryTfaState.bind(this)
    this.toggleMandatoryTfa = this.toggleMandatoryTfa.bind(this)
    this.updateMandatoryTfaSetting = this.updateMandatoryTfaSetting.bind(this)
  }

  toggleMandatoryTfa() { this.setState(prevState => ({isEnabled: !prevState.isEnabled})) }

  updateMandatoryTfaSetting() {
    FirmActions.updateFirmConfig({
      firmId: this.props.firmId,
      data: {firm_config: {mandatory_tfa_enabled: this.state.isEnabled}}
    })
    this.context.closeModal()
  }

  resetMandatoryTfaState() {
    this.setState({isEnabled: this.props.mandatoryTfaEnabled})
    this.context.closeModal()
  }

  // When the firm's organization has the org-level mandatory TFA flag on, the firm
  // setting is locked on and the AC requires we surface that to the AM with the
  // "This firm is a part of an organization..." copy and no Edit affordance. If
  // either flag is known to be enabled we prefer the known "Enabled" state over
  // the unresolved org-config fallback so the AM never sees "Unknown" when
  // mandatory TFA is already in effect.
  effectiveStatusText() {
    if (this.props.orgMandatoryTfaEnabled || this.props.mandatoryTfaEnabled) return 'Enabled'
    if (this.props.orgMandatoryTfaUnknown) return 'Unknown'
    return 'Disabled'
  }

  effectiveDescription() {
    if (this.props.orgMandatoryTfaEnabled) return ORG_OVERRIDE_NOTE
    if (this.props.mandatoryTfaEnabled) return TEXTS.enabled
    if (this.props.orgMandatoryTfaUnknown) return ORG_CONFIG_UNKNOWN_NOTE
    return TEXTS.disabled
  }

  render() {
    const isLockedByOrg = this.props.orgMandatoryTfaEnabled || this.props.orgMandatoryTfaUnknown
    const canEdit = this.props.isFirmActive && this.props.isAccountManager && !isLockedByOrg

    return (
      <ShadowWrapper className='edit-mandatory-tfa'>
        <div className='settings row-wrapper'>
          <p>Status: </p>
          <div className='column-wrapper'>
            <p>{this.effectiveStatusText()}</p>
            <p className='description'>{this.effectiveDescription()}</p>
            {
              canEdit &&
              (
                <div className='edit-config'>
                  <ControlButton faClass='fa-pencil-square-o' onClick={this.context.showModal} buttonText='Edit' />
                  <Modal visible={this.props.showModal}>
                    <ShadowHeader headerText='Mandatory Two-Factor Authentication for Clients and firm users' />
                    <div className='config-wrapper'>
                      <StatusToggle
                        description={TEXTS}
                        enabledChecked={this.state.isEnabled}
                        name='mandatory_tfa_enabled'
                        onChange={this.toggleMandatoryTfa}
                        statusText={{
                          disabled: 'Disabled',
                          enabled: 'Enabled'
                        }}
                      />
                    </div>
                    <div className='button-group'>
                      <Cancel onClick={this.resetMandatoryTfaState} />
                      <Continue onClick={this.updateMandatoryTfaSetting}>Save</Continue>
                    </div>
                  </Modal>
                </div>
              )
            }
            {!isLockedByOrg && <ContactAccountManagerNote isAccountManager={this.props.isAccountManager} />}
          </div>
        </div>
      </ShadowWrapper>
    )
  }
}

EditMandatoryTfa.contextTypes = {
  showModal: PropTypes.func,
  closeModal: PropTypes.func,
  modalClosed: PropTypes.func
}

EditMandatoryTfa.defaultProps = {
  mandatoryTfaEnabled: false,
  orgMandatoryTfaEnabled: false,
  orgMandatoryTfaUnknown: false,
  showModal: false
}

EditMandatoryTfa.propTypes = {
  firmId: PropTypes.string.isRequired,
  isAccountManager: PropTypes.bool,
  isFirmActive: PropTypes.bool,
  mandatoryTfaEnabled: PropTypes.bool,
  orgMandatoryTfaEnabled: PropTypes.bool,
  orgMandatoryTfaUnknown: PropTypes.bool,
  showModal: PropTypes.bool
}

export default modalWrapper(EditMandatoryTfa)
